import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vSelect from "vue-select";
import './css/global.css';

global.jQuery = require('jquery');
const $ = global.jQuery;

import NotifyPlugin from 'vue-easy-notify'
import 'vue-easy-notify/dist/vue-easy-notify.css'
//import "./css/vue-easy-notify.css";
Vue.use(NotifyPlugin);

import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

import Axios from 'axios'
Axios.defaults.withCredentials = true
//Axios.defaults.timeout = 60000
//Axios.defaults.xsrfCookieName= "XSRF-TOKEN"
//Axios.defaults.xsrfHeaderName= "X-XSRF-TOKEN"

if(process.env.NODE_ENV === 'development'){
    Axios.defaults.baseURL = '//test.vershinatyres';
}

Vue.prototype.$http = Axios;

import Pagination from 'vue-pagination-2';
Vue.component('pagination', Pagination);

import vmodal from 'vue-js-modal';
Vue.use(vmodal);
//Vue.use(vmodal, { dynamicDefault: {  adaptive: true } });

import { createPinia, PiniaVuePlugin } from 'pinia'
Vue.use(PiniaVuePlugin)
const pinia = createPinia()

Vue.config.productionTip = false

Vue.component("v-select", vSelect);

Vue.use(require('vue-moment'));

const cors = require('cors');

//import VueCookies from 'vue-cookies'
//Vue.use(VueCookies)
//Vue.$cookies.config('7d')
//Vue.$cookies.set('theme','default');
//Vue.$cookies.set('hover-time','1s');


//import { axios } from 'axios'
//Vue.use(PiniaVuePlugin)


const app = new Vue({
    router,
    pinia,
    cors,
    render: h => h(App)
}).$mount('#app');

export default app





